import { Box, Button, Divider, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import { BarcodeScanner } from 'react-barcode-scanner';
import 'react-barcode-scanner/polyfill';
import { sharedStyles } from '../../utils/Style';

type ScanBarcodeProps = {
  onScan: (barcode: string) => void;
  onCancel: () => void;
};

export const ScanBarcode = (props: ScanBarcodeProps) => {
  return (
    <Paper
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: 'fit-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          alignItems: 'center',
        }}
      >
        <Typography sx={{ ...sharedStyles.h5, fontWeight: 'bold' }}>
          Barkod Tara
        </Typography>

        <Box sx={{ flexGrow: 1 }} />
      </Box>

      <Divider />

      <Box sx={{ display: 'flex', maxWidth: 500 }}>
        <BarcodeScanner
          options={{
            formats: ['code_39', 'code_128', 'ean_13', 'ean_8'],
          }}
          onCapture={(barcodes) => {
            if (barcodes.length) {
              props.onScan(barcodes[0].rawValue);
            }
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
        <Box sx={{ flexGrow: 1 }} />

        <Button
          variant='contained'
          color='inherit'
          onClick={props.onCancel}
          sx={{ ...sharedStyles.buttonText }}
        >
          İptal
        </Button>
      </Box>
    </Paper>
  );
};
